<template>
  <div :class="$style.container">
    <div :class="$style.title">
      {{ title }}
    </div>

    <div :class="$style.subtitle">
      {{ paymentId }}
    </div>

    <slot name="default" />

    <div v-if="$slots.hasOwnProperty('footer')"  :class="$style.footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'TransactionCardTemplate',
  props: {
    title: {
      type: String,
      default: () => '',
    },
    paymentId: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +transaction-card-text
    display: flex
    flex-direction: column
    padding: 20px
    color: rgba(33, 33, 33, 1)
    background: rgba(255, 255, 255, 1)
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 5px

  .title
    margin-bottom: 10px

  .subtitle
    margin-bottom: 15px
    font-weight: 400
    font-size: 22px
    line-height: 26px

    +respond-to('medium')
      font-size: 24px
      line-height: 28px
</style>
